import { Squares2X2Icon, ListBulletIcon } from '@heroicons/react/24/outline';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';
import { useSearchParams } from 'react-router-dom';
import { LISTING_TYPE_PARAM } from '../../constants/search-params';

type Props = {
  listingType?: 'list' | 'cards';
};

const ChangeListingButton = ({ listingType }: Props) => {
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();

  const listingTypeParam = searchParams.get(LISTING_TYPE_PARAM) || listingType;

  const Icon = useMemo(() => {
    const iconProps = {
      width: 20,
      height: 20,
      color: 'white',
    };

    switch (listingTypeParam) {
      case 'list':
        return <ListBulletIcon {...iconProps} />;
      default:
        return <Squares2X2Icon {...iconProps} />;
    }
  }, [listingTypeParam]);

  const setListingType = useCallback(() => {
    const newListingType = listingTypeParam === 'list' ? 'cards' : 'list';

    setSearchParams((prev) => {
      prev.set(LISTING_TYPE_PARAM, newListingType);
      return prev;
    });
  }, [listingTypeParam, setSearchParams]);

  return (
    <button
      type="button"
      data-tooltip-content={t(COMMON_TRANSLATE_KEYS.CHANGE_LISTING_TYPE)}
      data-tooltip-id="tooltip"
      className="flex items-center border border-mainWhite rounded-xl p-3 h-fit cursor-pointer"
      onClick={() => setListingType()}
    >
      {Icon}
    </button>
  );
};

export default ChangeListingButton;
